import React from 'react';
import AllhomesArticleCard from './allhomes-article-card';
import styleBuilder from './allhomes-article-wrapper.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesArticleWrapper = _ref => {
  var _ref$articles = _ref.articles,
    allArticles = _ref$articles === void 0 ? [] : _ref$articles,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? 'column' : _ref$layout,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance,
    _ref$imagePosition = _ref.imagePosition,
    imagePosition = _ref$imagePosition === void 0 ? 'left' : _ref$imagePosition,
    _ref$fixedHeight = _ref.fixedHeight,
    fixedHeight = _ref$fixedHeight === void 0 ? true : _ref$fixedHeight,
    _ref$maxLines = _ref.maxLines,
    maxLines = _ref$maxLines === void 0 ? 3 : _ref$maxLines,
    _ref$headingTag = _ref.headingTag,
    headingTag = _ref$headingTag === void 0 ? 'h3' : _ref$headingTag,
    target = _ref.target,
    rel = _ref.rel;
  var styles = styleBuilder({
    layout
  });
  var articles = allArticles.slice(0, 3);
  if (layout !== 'two-row') {
    return ___EmotionJSX("div", {
      css: styles.articleWrapper
    }, articles.map(article => ___EmotionJSX(AllhomesArticleCard, {
      css: styles.card,
      key: article.url,
      article: article,
      appearance: appearance,
      imagePosition: imagePosition,
      fixedHeight: fixedHeight,
      maxLines: maxLines,
      headingTag: headingTag,
      target: target,
      rel: rel
    })));
  }
  var remainder = articles.length % 2;
  return ___EmotionJSX("div", {
    css: styles.articleWrapper
  }, remainder > 0 && ___EmotionJSX(AllhomesArticleCard, {
    article: articles[0],
    appearance: appearance,
    imagePosition: imagePosition,
    fixedHeight: fixedHeight,
    maxLines: maxLines,
    headingTag: headingTag,
    target: target,
    rel: rel
  }), articles.length > 1 && ___EmotionJSX("div", {
    css: styles.secondRow
  }, articles.slice(remainder).map(article => ___EmotionJSX(AllhomesArticleCard, {
    css: styles.card,
    key: article.url,
    article: article,
    appearance: appearance,
    imagePosition: imagePosition,
    fixedHeight: fixedHeight,
    maxLines: maxLines,
    headingTag: headingTag,
    target: target,
    rel: rel
  }))));
};
export default AllhomesArticleWrapper;